import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// types
import uppercase from '@drivesally/sally-fw/lib/type/types/uppercase.type';

export default attribute({
  type: TEXT,
  attribute: 'insurance_company_number',
  display: uppercase,
  input: uppercase,
  api: uppercase,
  label: {
    default: 'Insurance Company Number',
    short: 'Insurance Company Number',
  },
});
